import i18n from "@/locale"
import { Toast } from "vant"
import { TEMPERATURE_CONVERT_MAP, TEMPE_DIFF_CONVERT_MAP } from "@/utils/options"
import { convertTemp } from "@/utils/convert"
import { projectCreate, projectDetails } from "@/api/projectPre"

export const saveCurrentProject = ({ state, commit, dispatch, getters }, payload = null) => {
  return new Promise(async (resolve, reject) => {
    dispatch("app/showLoading", i18n.t("index").msg.Saving, { root: true })

    try {
      const projectSource = payload ?? state.currentProject
      const tempData = structuredClone(projectSource)
      await initTempStore({ state, commit }, [1, getters.tempUnit.value], tempData)
      const res = await projectCreate(tempData)
      await initTempStore({ state, commit }, [getters.tempUnit.value, 1], res.data)
      Toast.success(i18n.t("index").msg.Success)
      resolve(res.data)
    } catch (err) {
      console.error(err)
      Toast.fail(i18n.t("index").msg.FailedRetry)
      reject(err)
    } finally {
      dispatch("app/clearLoading", null, { root: true })
    }
  })
}

export const fetchProjectDetails = ({ state, commit, dispatch, getters }, _id) => {
  return new Promise(async (resolve, reject) => {
    dispatch("app/showLoading", i18n.t("index").msg.Loading, { root: true })

    try {
      const res = await projectDetails({ _id })
      commit("STORE_CURRENT_PROJECT", res.data)
      await initTempStore({ state, commit }, [getters.tempUnit.value, 1])
      resolve(res.data)
    } catch (err) {
      console.error(err)
      Toast.fail(i18n.t("index").msg.FailedRetry)
      reject(err)
    } finally {
      dispatch("app/clearLoading", null, { root: true })
    }
  })
}
export const initTempStore = async ({ state, commit }, [target, source] = [], datas = null) => {
  if (target == source) return
  const obj = datas ?? state.currentProject
  if (obj?.pre?.weatherProfile?.unit === target) return

  const maps = {
    ...Object.fromEntries(TEMPERATURE_CONVERT_MAP.map(key => [key, 0])),
    ...Object.fromEntries(TEMPE_DIFF_CONVERT_MAP.map(key => [key, 1]))
  }
  const traverseAndInitTemp = data => {
    for (let key in data) {
      if (data === obj && ["reviewChanges", "initChanges", "initSnapShot"].includes(key)) continue
      if (Array.isArray(data[key]) && Object.keys(maps).includes(key)) data[key] = data[key].map(val => convertTemp(val, target, source, maps[key]))
      else if (typeof data[key] === "object" && data[key] !== null) traverseAndInitTemp(data[key])
      else if (Object.keys(maps).includes(key)) data[key] = convertTemp(data[key], target, source, maps[key])
    }
  }
  traverseAndInitTemp(obj)
  const {
    weatherProfile: { unit, peakWater, offPeakWater, maxWater, minWater, ...res },
    ...items
  } = obj.pre || {}
  obj.pre = { ...items, weatherProfile: { ...res, unit: target, maxWater: maxWater || peakWater, minWater: minWater || offPeakWater } }
  if (obj.post?.weatherProfile != null && Object.keys(obj.post?.weatherProfile).length > 0) {
    obj.post = { ...obj.post, weatherProfile: { ...obj.post.weatherProfile, unit: target } }
  }
  commit("STORE_CURRENT_PROJECT", obj)
}



// WEBPACK FOOTER //
// ./src/store/modules/projectPre/actions.js